module.exports = __webpack_public_path__ + "static/directors5-d64d3483eab5ea96c0afb59442edb606.jpg";